import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBp1J11BEwtNjds9-jynlDWo_ubKv-Cl_o",
  authDomain: "portal.inovora.com",
  projectId: "inovora-tracker",
  storageBucket: "inovora-tracker.firebasestorage.app",
  messagingSenderId: "229669611567",
  appId: "1:229669611567:web:779e30d84ee5fa34e23eda",
  measurementId: "G-XZ6TFZZ10D",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
